import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    "filters": {
        type: "article",
        publishingYear: "",
        publishingMonth: "",
        fulltext: ""
    },
    results: null
};

const filterSlice = createSlice({
    name: 'filter',
    initialState,
    reducers: {
        setFulltext: (state, { payload }) => {
            state.filters.fulltext = payload;
        },
        clearFulltext: (state) => {
            state.filters.fulltext = "";
        },
        setYear: (state, { payload }) => {
            state.filters.publishingYear = payload;
        },
        setMonth: (state, { payload }) => {
            state.filters.publishingMonth = payload;
        },
        setResults: (state, { payload }) => {
            state.results = payload;
        },
        addResults: (state, { payload }) => {
            state.results.push(...payload);
        },
        clearMonth: (state) => {
            state.filters.publishingMonth = "";
        },
        clearFilters: (state) => {
            state.filters.publishingYear = "";
            state.filters.publishingMonth = "";
        },
        clearResults: (state) => {
            state.results = [];
        }
    }
});

export const {
    setYear,
    setMonth,
    setResults,
    addResults,
    clearMonth,
    clearFilters,
    clearResults,
    setFulltext,
    clearFulltext
} = filterSlice.actions;

export default filterSlice.reducer;